import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum KnowledgeBaseFileStatus {
  pending = 'pending',
  processing = 'processing',
  processed = 'processed',
  failed = 'failed',
}

export default class KnowledgeBaseFileModel extends Model {
  @attr('string') fileName!: string;
  @attr('string') fileType!: string;
  @attr('string') fileUrl!: string;
  @attr('number') fileSize?: number;
  @attr('string') status!: KnowledgeBaseFileStatus;
  @attr('date') createdAt!: Date;
  @attr('date') updatedAt!: Date;

  @belongsTo('property', { inverse: null, async: false })
  property?: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'ai-knowledge-base-file': KnowledgeBaseFileModel;
  }
}
